import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

function GoogleButton() {
  const onClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button data-testid="google-register-btn" type="button" variant="outline" onClick={onClick}
      className="w-full border-white/15 bg-transparent text-white hover:bg-white/5">
      <svg className="mr-1 h-4 w-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z"/></svg>
      Continue with Google
    </Button>
  );
}

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ first_name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created. Let's clear your first blocker.");
      navigate("/app");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Registration failed");
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Bring one blocker. Get one decisive move. Then go build.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label className="text-neutral-300">First name</Label>
          <Input data-testid="register-firstname" required value={form.first_name} onChange={set("first_name")}
            className="mt-1.5 border-white/12 bg-[var(--surface-raised)] text-white" placeholder="Maya" />
        </div>
        <div>
          <Label className="text-neutral-300">Email</Label>
          <Input data-testid="register-email" type="email" required value={form.email} onChange={set("email")}
            className="mt-1.5 border-white/12 bg-[var(--surface-raised)] text-white" placeholder="you@company.com" />
        </div>
        <div>
          <Label className="text-neutral-300">Password</Label>
          <Input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={set("password")}
            className="mt-1.5 border-white/12 bg-[var(--surface-raised)] text-white" placeholder="At least 6 characters" />
        </div>
        <Button data-testid="register-submit" type="submit" disabled={busy} className="btn-amber w-full">
          {busy ? "Creating…" : "Create account"}
        </Button>
      </form>
      <div className="my-5 flex items-center gap-3 text-xs text-neutral-600">
        <div className="h-px flex-1 bg-white/10" /> OR <div className="h-px flex-1 bg-white/10" />
      </div>
      <GoogleButton />
      <p className="mt-6 text-center text-sm text-neutral-400">
        Already have an account? <Link to="/login" className="text-[var(--amber)] hover:underline">Log in</Link>
      </p>
    </AuthShell>
  );
}
